import SiteFooter from "../components/SiteFooter";
import PublicPageHeader from "../components/PublicPageHeader";

const TermsPage = () => {
  return (
    <div className="min-h-screen" style={{ backgroundColor: "var(--secondary)" }}>
      <PublicPageHeader />
      <main className="px-6 py-12">
        <div className="max-w-4xl mx-auto bg-white rounded-2xl border p-8 md:p-10" style={{ borderColor: "var(--border)" }}>
          <h1 className="text-4xl font-bold mb-2" style={{ fontFamily: "Fraunces, serif", color: "var(--primary)" }}>
            Terms & Conditions
          </h1>
          <p className="text-sm opacity-60 mb-8">Effective Date: April 9, 2026</p>

          <div className="space-y-6 text-[15px] leading-7 opacity-90">

            <section>
              <h2 className="text-lg font-semibold mb-2">1. Acceptance of Terms</h2>
              <p>
                By accessing or using MoolTax ("the platform"), you agree to be bound by these
                Terms & Conditions. If you do not agree, please do not use the platform.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold mb-2">2. Nature of Service</h2>
              <p>
                MoolTax provides a technology-enabled platform for tax filing support, document
                collection, and related coordination assistance. MoolTax facilitates the process
                but does not itself file returns directly with authorities — that process involves
                qualified professionals coordinating through the platform.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold mb-2">3. User Responsibilities</h2>
              <ul className="list-disc pl-6 space-y-1">
                <li>You must provide accurate, complete, and authentic information and documents</li>
                <li>You are responsible for the correctness of all data submitted</li>
                <li>You must not upload fraudulent, misleading, or unauthorized documents</li>
                <li>You are responsible for maintaining the confidentiality of your login credentials</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold mb-2">4. Fees and Payments</h2>
              <p>
                Pricing for each plan is clearly displayed on the platform before purchase.
                Payment is required before filing work begins. Applicable taxes such as GST
                may be added to the displayed price where required by law.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold mb-2">5. Refunds and Cancellations</h2>
              <p>
                Refunds are subject to our Refund Policy available at mooltax.com/refund-policy.
                Once work on your case has commenced, fees may be non-refundable in full or in part.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold mb-2">6. No Guarantee of Outcome</h2>
              <p>
                MoolTax does not guarantee any specific tax refund amount, filing outcome,
                or processing timeline. Outcomes depend on user-provided information and
                applicable tax laws.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold mb-2">7. Intellectual Property</h2>
              <p>
                All content, design, and platform features are the property of MoolTax.
                You may not reproduce or distribute platform content without written permission.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold mb-2">8. Limitation of Liability</h2>
              <p>
                To the maximum extent permitted by applicable law, MoolTax shall not be liable
                for indirect, incidental, or consequential losses arising from use of the platform,
                including losses arising from inaccurate user submissions or third-party service delays.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold mb-2">9. Termination</h2>
              <p>
                We reserve the right to suspend or terminate accounts that violate these terms,
                engage in fraudulent activity, or misuse the platform.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold mb-2">10. Governing Law</h2>
              <p>
                These Terms are governed by the laws of India. Any disputes shall be subject
                to the exclusive jurisdiction of courts in New Delhi, India.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold mb-2">11. Contact</h2>
              <p>
                For any questions about these Terms, contact us at{" "}
                <a href="mailto:support@mooltax.com" className="underline">support@mooltax.com</a>.
              </p>
            </section>

          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
};

export default TermsPage;
